import { useDispatch } from 'react-redux';
import TextInput from '../../components/TextInput/TextInput';
import { useForm } from 'react-hook-form';
import Logo from '../../assets/Images/Squid/Logo.png';
import LogoFooter from '../../assets/Images/Squid/LogoFooter.png';
import Button from '../../components/Button/Button';
import {
  authenticateFetchAction,
  loginFetchAction,
} from '../../store/fetchActions/loginActions';
import Modal from '../../components/Modal/Modal';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import * as Styled from './Login.styles';
import { theme } from '../../styles/theme';
import { Typography } from '@material-ui/core';

const { mainColor, mainColorButtonHover } =
  theme.colors;

function Login() {
  const [loginData, setLoginData] = useState({
    CFPCNPJ: '',
    FONECEL: '',
    SENHA: '',
  });
  const [isModalTokenOpen, setIsModalTokenOpen] = useState(false);
  const [modalForgotPassword, setModalForgotPassword] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { handleSubmit: handleLogin, control: loginControl } = useForm({});
  const { handleSubmit: handleToken, control: tokenControl } = useForm({});
  const { handleSubmit: handleEmail, control: emailControl } = useForm({});

  const loginUser = (data) => {
    setLoginData(data);
    dispatch(authenticateFetchAction(data, openModalToken));
  };

  const sendToken = (TOKEN) => {
    dispatch(loginFetchAction({ ...loginData, TOKEN: TOKEN.TOKEN }, navigate));
  };

  const closeModalToken = () => setIsModalTokenOpen(false);
  const openModalToken = () => setIsModalTokenOpen(true);
  const closeModalForgotPassword = () => setModalForgotPassword(false);
  const openModalForgotPassword = () => setModalForgotPassword(true);
  return (
    <>
      <Modal open={isModalTokenOpen} close={closeModalToken} width={'38.889vw'}>
        <Styled.ModalContainer>
          <Styled.ImageContainer width="16.667vw" margin="0 0 3vw 0">
            <img src={Logo} alt="Logo"></img>
          </Styled.ImageContainer>
          <Styled.LoginInfo>
            <Typography variant="h4">Token</Typography>
            <Typography variant="h6">
              Digite o código enviado para o seu telefone
            </Typography>
          </Styled.LoginInfo>
          <div>
            <form onSubmit={handleToken(sendToken)}>
              <Styled.TokenModalContainer>
                <TextInput
                  label="Código"
                  name={'TOKEN'}
                  width={'31.250vw'}
                  control={tokenControl}
                  margin={'1vw 0'}
                  data-cy="input-token"
                  inputProps={{ role: 'token-input' }}
                />
                <Typography align="center">
                  Não recebeu o Codigo?<b> Reenviar</b>
                </Typography>
                <Typography align="center"></Typography>

                <Button
                  backgroundColor={mainColorButtonHover}
                  width="31.250vw"
                  hoverBGColor={mainColor}
                  hoverColor={mainColorButtonHover}
                  color={'white'}
                  type="submit"
                  margin={'8vw 0 2.847vw 0'}
                >
                  CONFIRMAR
                </Button>
              </Styled.TokenModalContainer>
            </form>
          </div>
        </Styled.ModalContainer>
      </Modal>
      <Styled.Container>
        <Styled.BackgroundImage></Styled.BackgroundImage>
        <Styled.LoginContainer>
          <Styled.ImageContainer width="16.667vw" margin="3.889vw 0 5.833vw 0">
            <img className="imageLogo" src={Logo} loading="eager" alt="Logo"></img>
          </Styled.ImageContainer>
          <Styled.LoginInfo>
            <Typography variant="h4">Entrar</Typography>
            <Typography variant="h6">
              Informe os dados para acessar a sua conta
            </Typography>
          </Styled.LoginInfo>
          <div>
            <form onSubmit={handleLogin(loginUser)}>
              <Styled.InputsContainer>
                <TextInput
                  label="CPF/CNPJ"
                  name={'CPFCNPJ'}
                  width={'31.250vw'}
                  control={loginControl}
                  margin={'1vw 0'}
                  required={true}
                  inputProps={{ role: 'cpf/cnpj-inputt' }}
                  variant="standard"
                />
                <TextInput
                  label="Telefone"
                  name={'FONECEL'}
                  width={'31.250vw'}
                  control={loginControl}
                  margin={'1vw 0'}
                  required={true}
                  inputProps={{ role: 'telefone-input', maxLength: 15 }}
                  variant="standard"
                />
                <TextInput
                  label="Senha"
                  name={'SENHA'}
                  width={'31.250vw'}
                  control={loginControl}
                  margin={'1vw 0'}
                  required={true}
                  type={'password'}
                  inputProps={{ role: 'senha-input', maxLength: 4 }}
                  variant="standard"
                />
                <Button
                  backgroundColor={mainColorButtonHover}
                  width="31.250vw"
                  borderRadius='10px'
                  height='2.9282576866764276vw'
                  hoverBGColor={mainColor}
                  hoverColor={mainColorButtonHover}
                  color={'white'}
                  type="submit"
                  margin={'1vw 0'}
                >
                  Entrar
                </Button>
              </Styled.InputsContainer>
            </form>
          </div>
        </Styled.LoginContainer>
        <Styled.Footer>
          <Styled.Slogan color="white">
            <Styled.ImageContainer width="3.889vw" margin="0 1.667vw 0 2.917vw">
              <img src={LogoFooter} alt="Logo" />
            </Styled.ImageContainer>
            <Typography variant="h4">
              Não é banco, <span>é muito mais</span>
            </Typography>
          </Styled.Slogan>
          <Styled.Slogan color="#FF557E" justifyContent="center">
            <Typography variant="h6" onClick={openModalForgotPassword}>
              {' '}
              Esqueceu sua senha?
            </Typography>
          </Styled.Slogan>
        </Styled.Footer>
      </Styled.Container>

      <Modal
        open={modalForgotPassword}
        close={closeModalForgotPassword}
        width={'38.889vw'}
      >
        <Styled.ModalContainer>
          <Styled.ImageContainer width="16.667vw" margin="0 0 3vw 0">
            <img src={Logo} alt="Logo"></img>
          </Styled.ImageContainer>
          <Styled.LoginInfo>
            <Typography variant="h4">Email</Typography>
            <Typography variant="h6">Digite o seu email cadastrado</Typography>
          </Styled.LoginInfo>
          <div>
            <form onSubmit={handleEmail(sendToken)}>
              <Styled.TokenModalContainer>
                <TextInput
                  label="Email"
                  name={'EMAIL'}
                  width={'31.250vw'}
                  control={emailControl}
                  margin={'1vw 0'}
                  data-cy="input-token"
                  inputProps={{ role: 'token-input' }}
                />

                <Button
                  backgroundColor={mainColorButtonHover}
                  width="31.250vw"
                  hoverBGColor={mainColor}
                  hoverColor={mainColorButtonHover}
                  color={'white'}
                  type="submit"
                  margin={'8vw 0 2.847vw 0'}
                >
                  CONFIRMAR
                </Button>
              </Styled.TokenModalContainer>
            </form>
          </div>
        </Styled.ModalContainer>
      </Modal>
    </>
  );
}

export default Login;
